import { createRouter, createWebHistory } from "vue-router";
import { RecuperarcontrasenaData, cambioContraseaData, loginData, rectanguloData, error404Data, error401Data, error500Data,error403Data,errorPasswordData, modalData } from "../js/data";
import EsquemaRepositoiry from "@/repositories/EsquemaRepositoiry";

const router = createRouter({
  history: createWebHistory(),
  // Reglas de rutas
  routes: [
    {
      // Constructor del formulario
      path: "/",
      name: "login",
      props: { ...loginData },
      component: () => import("../views/Login/UserLogin.vue"),
    },
    {
      // Constructor del formulario
      path: "/home",
      name: "home",
      component: () => import("../views/HomeForms.vue"),
      meta: { requiresAuth: true },
    },
    {
      // Constructor del formulario
      path: "/builder",
      name: "builder",
      component: () => import("../views/FormBuilder.vue"),
      meta: { requiresAuth: true },
    },
    {
      // Previsualizar formulario
      path: "/previsualize/:id",
      name: "previsualize",
      component: () => import("../views/FormPrev.vue"),
    },
    {
      // Reglas de flujo
      path: "/ReglaFlujo",
      name: "ReglaFlujo",
      component: () => import("../views/ReglaFlujo.vue"),
    },
    {
      // Reglas de diseño
      path: "/ReglaDiseno",
      name: "ReglaDiseno",
      component: () => import("../views/ReglaDiseño.vue"),
    },
    {
      // Reglas de diseño avanzadas
      path: "/ReglaDisenoAvanzada",
      name: "ReglaDisenoAvanzada",
      component: () => import("../views/ReglaDiseñoAvanzada.vue"),
    },
    {
      path: "/ViewReglasDiseno/:name/:id",
      name: "ViewReglasDiseno",
      component: () => import("@/views/ViewReglasDiseño.vue"),
    },
    // Entradas de formularios
    {
      path: "/FormEntries/:id",
      name: "FormEntries",
      component: () => import("@/views/FormEntries.vue"),
    },
    // Entradas Agenda
    {
      path: "/Agenda",
      name: "Agenda",
      component: () => import("@/views/AgendaModule.vue"),
    },
    // Registro de actividad de la app
    {
      path: "/Auditoria",
      name: "Auditoria",
      component: () => import("@/views/AuditLogs.vue"),
    },
    {
      path: "/Temas/:id",
      name: "Temas",
      component: () => import("@/views/FormThemes.vue"),
    },
    {
      path: "/recuperarcontrasena",
      name: "recuperarcontrasena",
      props: { ...RecuperarcontrasenaData },
      component: () => import("../views/Login/RecuperarContrasena.vue"),
    },
    {
      path: "/CambioContrasea",
      name: "CambioContrasea",
      props: { ...cambioContraseaData },
      component: () => import("../views/Login/CambioContrasea.vue"),
    },
    {
      path: "/mensajeEnviado",
      name: "mensajeEnviado",
      props: { ...rectanguloData },
      component: () => import("../components/Login/MensajeEnviado.vue"),
    },
    {
      path: "/error404",
      name: "error404",
      props: { ...error404Data },
      component: () => import("../views/Error404.vue"),
    },
    {
      path: "/error500",
      name: "error500",
      props: { ...error500Data },
      component: () => import("../views/Error500.vue"),
    },
    {
      path: "/error401",
      name: "error401",
      props: { ...error401Data },
      component: () => import("../views/Error401.vue"),
    },
    {
      path: "/error403",
      name: "error403",
      props: { ...error403Data },
      component: () => import("../views/Error403.vue"),
    },
    {
      path: "/errorPassword",
      name: "errorPassword",
      props: { ...errorPasswordData },
      component: ()=> import("../views/ErrorContraseña.vue")
    },
    {
      path: "/Modal",
      name: "Modal",
      component: () => import("../components/Login/ModalNotifi.vue"),
      props: { ...modalData },
    },
    {
      path: "/wolkvox",
      name: "wolkvox",
      props: {  },
      component: ()=> import("../components/IpWolkvox.vue")
    },
    {
      path: "/prediccion",
      name: "prediccion",
      props: {  },
      component: ()=> import("../views/prediccion.vue")
    },
    // QR Registro para codigo TOTP
    {
      path: "/ValidationQR",
      name: "ValidationQR",
      component: () => import("../views/QrGeneration.vue"),
    },
    // Validacion de codigo TOTP
    {
      path: "/ValidationCode",
      name: "ValidationCode",
      component: () => import("../views/EnterCode.vue"),
    },
    // Crear Usuarios Nuevos para la plataforma
    {
      path: "/CrearUsuario",
      name: "CrearUsuario",
      component: () => import("../views/CreateUser.vue"),
    }
  ],
  async scrollBehavior(to, from, savedPosition) {
    const publicPages = ["/","/errorPassword", "/login", "/ValidationQR", "/ValidationCode", "/CrearUsuario", "/recuperarcontrasena", "/CambioContrasea", "/Auditoria", "/mensajeEnviado", "/error404", "/error500", "/error401", "/Modal","/error403", "/previsualize"+"/id"];
    const isPrevisualizeRoute = /^\/previsualize\/\d*/.test(to.path);
    const isFormEntriesRoute = /^\/FormEntries\/\d*/.test(to.path);
    const Temas = /^\/Temas\/\d*/.test(to.path);
    const isReglaDiseñoAvanzada = /^\/ReglaDiseñoAvanzada\/\w*/.test(to.path);
    const isRulesDesingRoute = /^\/ViewReglasDiseno\/\w*/.test(to.path);
    const authRequired = !publicPages.includes(to.path) && !isPrevisualizeRoute  && !isRulesDesingRoute && !Temas && !isFormEntriesRoute && !isReglaDiseñoAvanzada;
    const pathToValidate = to.path;

    if(authRequired ){
      await EsquemaRepositoiry.Establecer_permisos_Url({ path: pathToValidate });
    }
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

export default router;